import logo from "@/assets/demore-logo.png";
import { cn } from "@/lib/utils";

export function Logo({
  variant = "full",
  className,
}: {
  variant?: "full" | "wordmark";
  className?: string;
}) {
  if (variant === "wordmark") {
    // Pure gold text for dark admin surfaces.
    return (
      <span
        className={cn(
          "font-head font-bold tracking-tight text-gold select-none",
          className,
        )}
      >
        demore
      </span>
    );
  }
  return (
    <img
      src={logo}
      alt="Demore — Just for You"
      className={cn("block h-auto w-auto", className)}
      draggable={false}
    />
  );
}
